export default [
  {
    title: 'breadcrumb.assistant',
    route: 'list-assistant',
    icon: '',
    resource: 'assistant',
    action: 'read',
  },
  {
    title: 'breadcrumb.assistantVvip',
    route: 'list-assistant-vvip',
    icon: '',
    resource: 'assistantvvip',
    action: 'read',
  },
]
